<!-- this displays the jstree loading message with the spinner -->
<div id="jstree_spinner">
  <mat-spinner></mat-spinner>
</div>
